// extracted by mini-css-extract-plugin
export default {"Textarea":"xk7YQKas","name":"hcDuIoJR","content":"EO839N5z","data":"VGnZBRUs","input":"D47pCmVS","note":"vUdTVG6E","errorMessage":"taWo8oHH"};
    if(module.hot) {
      // 1764331288626
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  